export const schoolwork12: { app?: any} = window['schoolwork12'];
